
import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { mensagemDeErro } from '@core/errors';
import { UsuarioTrocarSenha } from '@modules/usuarios/model/usuario-trocar-senha';
import { UsuariosService } from '@modules/usuarios/services/usuarios.service';
import { NotificacaoToasterService } from '@shared/services/notificacao-toaster.service';
import { AppButtonDirective } from '@shared/ui/button/app-button.directive';
import { AppInputDirective } from '@shared/ui/input/input.directive';
import { AppLabelDirective } from '@shared/ui/label/label.directive';

import { ModalFooterComponent } from '../../../../../shared/ui/modal/components/modal-footer.component';
import { ModalHeaderComponent } from '../../../../../shared/ui/modal/components/modal-header.component';
import { ModalComponent } from '../../../../../shared/ui/modal/modal.component';
import { ModalTrocarSenhaService } from '../../services/modal-trocar-senha.service';

@Component({
  selector: 'app-modal-trocar-senha',
  imports: [
    ModalComponent,
    ModalHeaderComponent,
    ReactiveFormsModule,
    AppInputDirective,
    AppButtonDirective,
    ModalFooterComponent,
    AppLabelDirective
],
  templateUrl: './modal-trocar-senha.component.html',
  styleUrl: './modal-trocar-senha.component.scss',
})
export class ModalTrocarSenhaComponent {
  protected readonly modalTrocarSenhaService = inject(ModalTrocarSenhaService);
  protected readonly usuariosService = inject(UsuariosService);
  protected readonly _toastService = inject(NotificacaoToasterService);

  protected errosApi = [];

  formulario = new FormGroup({
    senhaAtual: new FormControl<string | null>(null),
    novaSenha: new FormControl<string | null>(null, Validators.required),
    confirmarNovaSenha: new FormControl<string | null>(null, Validators.required),
  });

  trocarSenha() {
    if (!this.senhasIguais()) {
      return this._toastService.error('As senhas não são iguais!');
    }

    const usuario: UsuarioTrocarSenha = {
      senhaAtual: this.formulario.get('senhaAtual')?.value ?? '',
      usuarioId: this.usuariosService.usuarioLogado?.id ?? '',
      novaSenha: this.formulario.get('novaSenha')?.value ?? '',
      confirmacaoNovaSenha: this.formulario.get('confirmarNovaSenha')?.value ?? '',
    };

    this.usuariosService.trocarSenha(usuario).subscribe({
      next: () => {
        this.modalTrocarSenhaService.toggleModal();
        this.formulario.reset();
        this.errosApi = [];
        this._toastService.sucesso('Senha alterada com sucesso!');
      },
      error: (err) => {
        const { error } = err;
        console.log(error);
        this.errosApi = error?.erros ?? [];
        this._toastService.error(mensagemDeErro(err, 'Ops! Houve um erro, tente novamente!'));
      },
    });
  }

  senhasIguais(): boolean {
    return (
      this.formulario.get('novaSenha')?.value === this.formulario.get('confirmarNovaSenha')?.value
    );
  }
}
